import Choices       from 'choices.js';
import escape        from 'lodash-es/escape';
import metaContent   from '../fn/metaContent';
import setUrlParam   from '../fn/setUrlParam';
import urlWithParams from '../fn/urlWithParams';

const initNode = (node) => {
  const prefix = metaContent('appRoot');
  node.classList.add('choices_initialized');

  const choices = new Choices(node, {
    placeholderValue: 'Start typing a [whatever]',
    searchChoices: false,
    searchFloor: 3,
    shouldSort: false,
    itemSelectText: '',
  });

  const apiUrl = prefix + '/api/by_session/mimic_users';
  const lookupDelay = 100;
  const lookupCache = {};
  let lookupTimeout = null;

  const serverLookup = function() {
    const query = choices.input.value;

    if (query in lookupCache) {
      populateOptions(lookupCache[query]);
    } else {
      fetch(urlWithParams(apiUrl, { term: query }), { credentials: 'include' })
        .then(response => response.json())
        .then(json => {
          const options = json.results.map(item => { return { ...item, text: escape(item.text) } } );
          lookupCache[query] = options;
          populateOptions(options);
        })
        .catch(error => console.error(error));
    }
  };

  var populateOptions = function(options) {
    choices.setChoices(options, 'id', 'text', true);
  };

  node.addEventListener('search', function(event) {
    clearTimeout(lookupTimeout);
    lookupTimeout = setTimeout(serverLookup, lookupDelay);
  });

  node.addEventListener('choice', function(event) {
    choices.clearChoices();
    setUrlParam('mimic_user_id', event.detail.choice.value);
  });
};

const initAll = () => {
  const nodes = document.querySelectorAll('.custom-choices.mimic-user-choices:not(.choices_initialized)');
  Array.from(nodes).forEach(node => initNode(node));
};

const start = () => {
  document.addEventListener('page:load', initAll);
  document.addEventListener('ajax:success', initAll);
};

export default { initAll, start };
